import { render } from "./_layout.vue?vue&type=template&id=c522ab36"
import script from "./_layout.vue?vue&type=script&lang=js"
export * from "./_layout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__